export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-8 animate-fade-up">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#1A1A1A]">{title}</h1>
        {subtitle && <p className="text-sm text-[#5C5C54] mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const TONES = {
  green: "bg-emerald-50 text-emerald-800 border border-emerald-200",
  orange: "bg-orange-50 text-orange-800 border border-orange-200",
  amber: "bg-amber-50 text-amber-800 border border-amber-200",
  gray: "bg-stone-100 text-stone-700 border border-stone-200",
  blue: "bg-cyan-50 text-cyan-800 border border-cyan-200",
  red: "bg-red-50 text-red-800 border border-red-200",
};

export function StatusBadge({ children, tone = "gray", testid }) {
  return (
    <span data-testid={testid}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${TONES[tone] || TONES.gray}`}>
      {children}
    </span>
  );
}

export function statusTone(status) {
  const s = (status || "").toLowerCase();
  if (["paid", "approved", "active", "awarded"].includes(s)) return "green";
  if (["pending", "reporting", "submitted"].includes(s)) return "amber";
  if (["unpaid", "closed", "inactive"].includes(s)) return "gray";
  if (["rejected", "overdue"].includes(s)) return "red";
  return "gray";
}
